import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getFromLS, removeLS, writetoLS } from '../utils/utils';

const qs = require('qs');

const useJobContentAsAdmin = () => {
  const userInfos = getFromLS('userInfos') || '';
  const { search } = useLocation();
  const [consultantId, setConsultantId] = useState<string>();

  const verifyAdminUsingConsultantId = () => {
    const query = qs.parse(search, { ignoreQueryPrefix: true });
    if (query.consultantId) {
      // store"éaœ
      setConsultantId(query.consultantId);
      writetoLS('adminConsultantToCheck', query.consultantId);
    } else if (getFromLS('adminConsultantToCheck')) {
      setConsultantId(getFromLS('adminConsultantToCheck')!);
    } else {
      // redirect back
      removeLS('adminConsultantToCheck');
      window.close();
    }
  };

  const getConsultantId = () => {
    const currentUser = JSON.parse(userInfos);
    if (!currentUser.company_user_role && currentUser.role.id === 3) {
      // admin root
      if (!getFromLS('adminConsultantToCheck')) {
        alert("Vous n'avez pas encore spécifié le consultant");
        window.close();
      }
      setConsultantId(getFromLS('adminConsultantToCheck') as string);
      return getFromLS('adminConsultantToCheck');
    }
    if (currentUser.company_user_role && [1, 2, 3].indexOf(currentUser.company_user_role.id) > -1) {
      // admin n+1, n+2, n+3
      if (!getFromLS('adminConsultantToCheck')) {
        alert("Vous n'avez pas encore spécifié le consultant");
        window.close();
      }
      setConsultantId(getFromLS('adminConsultantToCheck') as string);
      return getFromLS('adminConsultantToCheck');
    }
    setConsultantId(currentUser.id);
    removeLS('adminConsultantToCheck');
    return currentUser.id;
  };

  const verify = async () => {
    const currentUser = JSON.parse(userInfos);
    if (!currentUser.company_user_role && currentUser.role.id === 3) {
      // admin root
      return verifyAdminUsingConsultantId();
    }
    if (currentUser.company_user_role && [1, 2, 3].indexOf(currentUser.company_user_role.id) > -1) {
      // admin n+1, n+2, n+3
      return verifyAdminUsingConsultantId();
    }
    removeLS('adminConsultantToCheck');
    return true;
  };

  return {
    verify,
    consultantId,
    getConsultantId,
  };
};

export default useJobContentAsAdmin;
